import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loading } from "@/components/States";
import { api, formatError } from "@/lib/api";

const MODELS = [["claude-sonnet-4-5-20250929", "Claude Sonnet 4.5 (quality)"], ["claude-haiku-4-5-20251001", "Claude Haiku 4.5 (economical)"]];

export default function AdminSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)); }, []);
  const save = async () => {
    try {
      const { ai_enabled, daily_ai_limit, model, temperature, max_tokens, daily_quiz_size } = s;
      setS((await api.put("/admin/settings", { ai_enabled, daily_ai_limit: Number(daily_ai_limit), model, temperature: Number(temperature), max_tokens: Number(max_tokens), daily_quiz_size: Number(daily_quiz_size) })).data);
      toast.success("Settings saved");
    } catch (e) { toast.error(formatError(e)); }
  };
  if (!s) return <Loading />;
  const num = (k, label, props) => (
    <div className="flex flex-col gap-2"><Label>{label}</Label><Input data-testid={`settings-${k}`} type="number" value={s[k]} onChange={(e) => setS({ ...s, [k]: e.target.value })} {...props} /></div>
  );
  return (
    <div data-testid="admin-settings" className="grid max-w-2xl gap-5 rounded-xl border border-line bg-surface p-6">
      <label className="flex items-center gap-3 text-sm font-medium"><Switch data-testid="settings-ai-enabled" checked={s.ai_enabled} onCheckedChange={(v) => setS({ ...s, ai_enabled: v })} />AI generation enabled</label>
      <div className="flex flex-col gap-2">
        <Label>Model</Label>
        <Select value={s.model} onValueChange={(v) => setS({ ...s, model: v })}>
          <SelectTrigger data-testid="settings-model"><SelectValue /></SelectTrigger>
          <SelectContent>{MODELS.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        {num("daily_ai_limit", "Fallback daily AI limit (learner limits are set per plan)", { min: 0 })}
        {num("daily_quiz_size", "Daily quiz size", { min: 3, max: 20 })}
        {num("temperature", "Temperature (0–1)", { step: 0.1, min: 0, max: 1 })}
        {num("max_tokens", "Max output tokens", { min: 1000, max: 16000 })}
      </div>
      <p className="text-xs text-ink-3">Quiz sizes available to learners: {s.allowed_quiz_sizes.join(", ")}. Per-minute burst limit: 6 generations.</p>
      <Button data-testid="settings-save-btn" onClick={save} className="justify-self-start">Save settings</Button>
    </div>
  );
}
